
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("h59ig", function(module, exports) {

$parcel$export(module.exports, "handleLogin", () => $c6fa1cc9bf76c207$export$da4fc2bf424da4ca);
$parcel$export(module.exports, "handleRegister", () => $c6fa1cc9bf76c207$export$23426a7a128a6d6e);
$parcel$export(module.exports, "handleLogout", () => $c6fa1cc9bf76c207$export$297d1113e3afbc21);
// Fungsi untuk login
function $c6fa1cc9bf76c207$export$da4fc2bf424da4ca(event) {
    event.preventDefault(); // Mencegah form untuk submit secara default
    // Ambil nilai dari input form
    const email = document.getElementById('email').value;
    const password = document.getElementById('password').value;
    // Validasi form
    if (!email || !password) {
        $c6fa1cc9bf76c207$var$showError('Harap isi semua kolom!');
        return;
    }
    // Validasi email menggunakan regex (format email yang valid)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
        $c6fa1cc9bf76c207$var$showError('Format email tidak valid!');
        return;
    }
    // Tampilkan loading spinner saat proses login berjalan
    document.getElementById('loading-spinner').style.display = 'block';
    // Proses login, misalnya dengan memeriksa di database atau API
    // Ini simulasi, Anda dapat menggantinya dengan logika API sebenarnya
    $c6fa1cc9bf76c207$var$loginUser(email, password).then((user)=>{
        // Menyimpan informasi pengguna ke localStorage
        localStorage.setItem('user', JSON.stringify(user));
        // Menyembunyikan spinner dan redirect ke halaman utama
        document.getElementById('loading-spinner').style.display = 'none';
        window.location.href = '/html/home.html';
    }).catch((error)=>{
        document.getElementById('loading-spinner').style.display = 'none';
        $c6fa1cc9bf76c207$var$showError(`Gagal login: ${error.message}`);
    });
}
function $c6fa1cc9bf76c207$export$23426a7a128a6d6e(event) {
    event.preventDefault(); // Mencegah form untuk submit secara default
    // Ambil nilai dari input form
    const email = document.getElementById('email').value;
    const password = document.getElementById('password').value;
    const confirmPassword = document.getElementById('confirm-password').value;
    // Validasi form
    if (!email || !password || !confirmPassword) {
        $c6fa1cc9bf76c207$var$showError('Harap isi semua kolom!');
        return;
    }
    // Validasi email
    if (!$c6fa1cc9bf76c207$var$validateEmail(email)) {
        $c6fa1cc9bf76c207$var$showError('Email tidak valid!');
        return;
    }
    // Validasi password
    if (password !== confirmPassword) {
        $c6fa1cc9bf76c207$var$showError('Password dan Konfirmasi Password tidak cocok!');
        return;
    }
    if (password.length < 6) {
        $c6fa1cc9bf76c207$var$showError('Password harus memiliki minimal 6 karakter!');
        return;
    }
    // Tampilkan loading spinner saat proses pendaftaran
    document.getElementById('loading-spinner').style.display = 'block';
    // Proses pendaftaran
    $c6fa1cc9bf76c207$var$registerUser(email, password).then((user)=>{
        // Menyembunyikan spinner dan redirect ke halaman login
        document.getElementById('loading-spinner').style.display = 'none';
        window.location.href = '/html/login.html'; // Arahkan ke halaman login setelah registrasi berhasil
    }).catch((error)=>{
        document.getElementById('loading-spinner').style.display = 'none';
        $c6fa1cc9bf76c207$var$showError(`Gagal registrasi: ${error.message}`);
    });
}
function $c6fa1cc9bf76c207$export$297d1113e3afbc21() {
    localStorage.removeItem('user'); // Hapus informasi user dari localStorage
    window.location.href = '/html/login.html'; // Arahkan ke halaman login setelah logout
}
// Fungsi untuk menampilkan pesan error
function $c6fa1cc9bf76c207$var$showError(message) {
    const errorMessageElement = document.getElementById('error-message');
    errorMessageElement.innerText = message;
    errorMessageElement.style.display = 'block';
}
// Fungsi validasi email
function $c6fa1cc9bf76c207$var$validateEmail(email) {
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return regex.test(email);
}
// Fungsi simulasi login (ganti dengan logika backend nyata)
function $c6fa1cc9bf76c207$var$loginUser(email, password) {
    return new Promise((resolve, reject)=>{
        // Simulasi login
        setTimeout(()=>{
            if (email === "test@example.com" && password === "password123") resolve({
                username: 'Test User',
                email: email
            }); // Simulasi user berhasil login
            else reject(new Error('Email atau password salah'));
        }, 1000);
    });
}
// Fungsi simulasi registrasi (ganti dengan logika backend nyata)
function $c6fa1cc9bf76c207$var$registerUser(email, password) {
    return new Promise((resolve, reject)=>{
        // Simulasi registrasi
        setTimeout(()=>{
            if (email === "test@example.com") reject(new Error('Email sudah terdaftar'));
            else resolve({
                username: email,
                email: email
            }); // Simulasi registrasi berhasil
        }, 1000);
    });
}

});


parcelRequire("h59ig");

//# sourceMappingURL=login.506904da.js.map
